import { useQuery } from "@tanstack/react-query";

import { getPinnedMarkets } from "@/api/pinnedMarkets";

export enum PinnedMarketsQueryKeys {
  All = "pinnedMarkets"
}

// The user's pinned market group numbers (per-user, permanent, language-
// independent). Used to render pin state + the "pin" tab in the markets card.
export const usePinnedMarkets = () =>
  useQuery({
    queryKey: [PinnedMarketsQueryKeys.All],
    queryFn: ({ signal }) => getPinnedMarkets({ signal })
  });
